"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLIENT_STORAGE_ALL = exports.CLIENT_STORAGE_COOKIES = exports.CLIENT_STORAGE_LOCAL_STORAGE = void 0;
var CLIENT_STORAGE_LOCAL_STORAGE = 'CLIENT_STORAGE_LOCAL_STORAGE';
exports.CLIENT_STORAGE_LOCAL_STORAGE = CLIENT_STORAGE_LOCAL_STORAGE;
var CLIENT_STORAGE_COOKIES = 'CLIENT_STORAGE_COOKIES'; // used to read/write to both local storage and cookies
// priority: localStorage > cookies

exports.CLIENT_STORAGE_COOKIES = CLIENT_STORAGE_COOKIES;
var CLIENT_STORAGE_ALL = 'CLIENT_STORAGE_ALL';
exports.CLIENT_STORAGE_ALL = CLIENT_STORAGE_ALL;